// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:26:41

export default {
  "id": "geometry-open-world",
  "slug": "geometry-open-world",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/57281179dd58447ab2bd5ddee722da2f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/57281179dd58447ab2bd5ddee722da2f/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Geometry Open World",
      "description": "Geometry Open World is a fast-paced 2D action game where players pilot a ship through perilous obstacles, engage in thrilling battles against diverse enemies, and take on epic boss fights. With a vibrant and dynamic open world, strategic upgrades, and powerful abilities, you can chart your own path to triumph. Will you conquer the challenges, defeat the bosses, and rise to become the ultimate champion in this open-world geometric action adventure?",
      "instructions": "Controls\nA or left arrow key = move left\nD or right arrow key = move right\nQ = use shield\nE = use cannons\nLeft mouse button = interact with in-game UI",
      "genres": [
        "Battle",
        "Casual"
      ],
      "tags": [
        "dash",
        "geometry",
        "music",
        "shoot-em-up"
      ]
    },
    "zh-CN": {
      "title": "几何开放世界",
      "description": "《几何开放世界》是一款节奏快速的双位动作游戏，玩家驾驶飞船穿越危险障碍，与各种敌人展开惊心动魄的战斗，并参与史诗般的Boss战。在这充满活力和动态感的开放世界中，战略升级和强大能力，您可以规划自己的胜利之路。你将征服挑战，击败Boss，成为这款开放世界几何动作冒险中的终极冠军吗？",
      "instructions": "控制\nA 或左箭头键 = 向左移动\nD 或右箭头键 = 向右移动\nQ = 使用盾牌\nE = 使用大炮\n左鼠标键 = 与游戏界面交互",
      "genres": [
        "战斗",
        "休闲"
      ],
      "tags": [
        "冲刺",
        "几何",
        "音乐",
        "射击游戏"
      ]
    },
    "zh-TW": {
      "title": "幾何開放世界",
      "description": "幾何開放世界是一款快節奏的2D動作遊戲，玩家操控船隻穿越危險的障礙，與多種敵人進行刺激的戰鬥，並挑戰經典的BOSS戰。擁有豐富多樣的開放世界、策略升級和強大能力，你可以打造屬於自己的勝利之路。你將會征服挑戰，擊敗BOSS，並成為這開放世界幾何動作冒險中的最終冠軍嗎？",
      "instructions": "控制\nA 或左方向鍵 = 向左移動\nD 或右方向鍵 = 向右移動\nQ = 使用護盾\nE = 使用砲台\n左鍵 = 互動遊戲內介面",
      "genres": [
        "戰鬥",
        "休闲"
      ],
      "tags": [
        "冲刺",
        "幾何",
        "音樂",
        "射擊遊戲"
      ]
    },
    "zh-HK": {
      "title": "幾何開放世界",
      "description": "幾何開放世界是一款節奏快速的2D動作遊戲，玩家操控船隻穿越危險的障礙，與多種敵人進行刺激的戰鬥，並挑戰經典大頭目。擁有生動活潑的開放世界、策略升級和強大能力，你可以制定自己的勝利之路。你會征服挑戰，擊敗大頭目，成為這開放世界幾何動作冒險中的最終冠軍嗎？",
      "instructions": "控制\nA 或左箭頭鍵 = 向左移動\nD 或右箭頭鍵 = 向右移動\nQ = 使用護盾\nE = 使用砲台\n左鍵 = 互動遊戲內介面",
      "genres": [
        "戰鬥",
        "休閒"
      ],
      "tags": [
        "衝刺",
        "幾何",
        "音樂",
        "射擊遊戲"
      ]
    },
    "ja": {
      "title": "幾何オープンワールド",
      "description": "ジオメトリオープンワールドは、高速な2Dアクションゲームで、プレイヤーは危険な障害を通過し、多様な敵との緊迫した戦闘に参加し、壮大なボス戦を挑みます。豊かにダイナミックなオープンワールド、戦略的なアップグレード、そして強力な能力を持って、勝利への道を切り開くことができます。このオープンワールドの幾何学的アクションアドベンチャーで、挑戦を克服し、ボスを倒し、究極のチャンピオンに輝くことができるでしょうか？",
      "instructions": "コントロール\nAまたは左矢印キー＝左に移動\nDまたは右矢印キー＝右に移動\nQ＝盾を使う\nE＝砲台を使う\n左マウスボタン＝ゲーム内UIとの対話",
      "genres": [
        "バトル",
        "カジュアル"
      ],
      "tags": [
        "ダッシュ",
        "幾何学",
        "音楽",
        "シューティングゲーム"
      ]
    },
    "ko": {
      "title": "지오메트리 오픈 월드",
      "description": "지오메트리 오픈 월드는 빠른 템포의 2D 액션 게임으로, 플레이어는 위험한 장애물을 통과하며 다양한 적과의 열혈 전투에 참여하고, 전설적인 보스와의 대결을 맞서는 것을 목표로 합니다. 생동감 넘치고 다양한 오픈 월드, 전략적인 업그레이드, 강력한 능력을 통해 자신만의 승리의 길을 탐험할 수 있습니다. 도전을克服하고 보스를 물리치고, 이 오픈 월드 지오메트리 액션 어드벤처에서 최종 챔피언이 되시겠습니까?",
      "instructions": "컨트롤\nA나 왼쪽 방향키 = 왼쪽으로 이동\nD나 오른쪽 방향키 = 오른쪽으로 이동\nQ = 방패 사용\nE = 대포 사용\n왼쪽 마우스 버튼 = 게임 UI와 상호작용",
      "genres": [
        "전투",
        "캐주얼"
      ],
      "tags": [
        "dash: dash\ngeometry: 기하학\nmusic: 음악\nshoot-em-up: 쏘아라 게임"
      ]
    },
    "fr": {
      "title": "Géométrie Monde Ouvert",
      "description": "Geometry Open World est un jeu d'action 2D rapide où les joueurs pilotent un navire à travers des obstacles dangereux, s'engagent dans des batailles époustouflantes contre des ennemis divers, et affrontent des combats épiques contre des boss. Avec un monde ouvert vibrant et dynamique, des améliorations stratégiques et des capacités puissantes, vous pouvez tracer votre propre chemin vers la victoire. Serez-vous prêt à surmonter les défis, à vaincre les boss et à devenir le champion ultime dans cette aventure d'action géométrique ouverte ?",
      "instructions": "Contrôles\nA ou flèche de gauche = déplacement vers la gauche\nD ou flèche de droite = déplacement vers la droite\nQ = utiliser le bouclier\nE = utiliser les canons\nBouton gauche de la souris = interagir avec l'UI de jeu",
      "genres": [
        "Bataille",
        "Casual"
      ],
      "tags": [
        "décathlon",
        "géométrie",
        "musique",
        "shoot-em-up"
      ]
    }
  }
};
